/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Rag_QuestionInputs */

const en_faq_rag_question = /** @type {(inputs: Faq_Rag_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can you build an AI knowledge base or internal assistant on our company data?`)
};

const lv_faq_rag_question = /** @type {(inputs: Faq_Rag_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai varat izveidot AI zināšanu bāzi vai iekšējo asistentu ar mūsu uzņēmuma datiem?`)
};

/**
* | output |
* | --- |
* | "Can you build an AI knowledge base or internal assistant on our company data?" |
*
* @param {Faq_Rag_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_rag_question = /** @type {((inputs?: Faq_Rag_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Rag_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_rag_question(inputs)
	return en_faq_rag_question(inputs)
});